import { useNavigate } from 'react-router-dom';
import { seoArticles } from '@/mocks/homeData';

export default function SEOArticlesSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
            itaobuyspreadsheet Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2 md:mt-3 max-w-md">
            Expert-written guides to help you master the{' '}
            <strong className="text-foreground-800">itaobuyspreadsheet</strong> system. Updated regularly with new insights and strategies.
          </p>
        </div>

        {/* Articles grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {seoArticles.map((article) => (
            <article
              key={article.slug}
              className="rounded-xl bg-background-50 overflow-hidden group cursor-pointer"
              onClick={() => navigate(`/article/${article.slug}`)}
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 whitespace-nowrap">
                  Read Article
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}